module.exports = __webpack_public_path__ + "static/wordingbias-8a55aecb06a97f162c3d1fcf3bad40da.png";